import React, { useContext, useEffect, useState } from "react";
import { Carousel, CarouselCaption, CarouselControl, CarouselItem } from "reactstrap";
import { ITINERARY } from "../../../constants/editor";
import { EditorContext } from "../../../containers/editor/EditorLayout";

const PricingTableImageCaraousel = props => {
  let { metadata } = useContext(EditorContext);

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const items = props.showModal;

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const slides = items.map(item => {
    return (
      <CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={item.src}>
        <img src={item.src} alt={item.altText} />
      </CarouselItem>
    );
  });

  useEffect(() => {
    if (metadata?.activeWidgetType?.[0] === ITINERARY || ITINERARY === props?.activeWidgetType) {
      const targetIndex = items.findIndex(item => item.active);
      setActiveIndex(targetIndex);
    }
  }, []);

  return (
    <>
      <Carousel activeIndex={activeIndex} next={next} previous={previous}>
        {slides}
        <CarouselControl
          direction="prev"
          className={{ ["disable"]: items.length == 1 }}
          directionText="Previous"
          onClickHandler={previous}
        />
        <CarouselControl
          direction="next"
          className={{ ["disable"]: items.length == 1 }}
          directionText="Next"
          onClickHandler={next}
        />
      </Carousel>
      <CarouselCaption captionHeader={`${activeIndex + 1}/${items.length}`} />
    </>
  );
};

export default PricingTableImageCaraousel;
